// Compresse une image avant upload pour accélérer le réseau et l'analyse IA.
// - Resize à maxDim sur le plus grand côté (préserve le ratio)
// - Encode en JPEG qualité ~0.82
// - Retombe sur le fichier original si compression échoue ou si déjà petit

const DEFAULT_MAX_DIM = 1280;
const DEFAULT_QUALITY = 0.78;
const SKIP_IF_BELOW_BYTES = 300 * 1024; // 300 KB

export async function compressImage(
  file,
  { maxDim = DEFAULT_MAX_DIM, quality = DEFAULT_QUALITY } = {}
) {
  if (!file || !file.type?.startsWith('image/')) return file;
  if (file.size && file.size < SKIP_IF_BELOW_BYTES) return file;

  try {
    const dataUrl = await readAsDataURL(file);
    const img = await loadImage(dataUrl);

    const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
    if (scale >= 1 && file.size < 900 * 1024) return file;

    const w = Math.round(img.width * scale);
    const h = Math.round(img.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, w, h);

    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', quality)
    );
    if (!blob) return file;

    const baseName = (file.name || 'photo').replace(/\.[^.]+$/, '');
    return new File([blob], `${baseName}.jpg`, { type: 'image/jpeg' });
  } catch (err) {
    console.warn('Image compression failed, using original', err);
    return file;
  }
}

function readAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = reject;
    i.src = src;
  });
}
